import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Cursor from '../components/Cursor';
import onlyIf from '../hocs/onlyIf';
function mapStateToProps(state) {
    return {
        cursorCoords: state.replay.cursorCoords,
        clicks: state.replay.clicks.map(function (click) { return (__assign(__assign({}, click), { coords: click.coords })); }),
        isPlaying: state.replay.status === 'PLAYING',
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.isPlaying; }))(Cursor);
